import { useQuery } from '@tanstack/react-query';
import { makeRemoteGetAuditConfig } from 'main/factories/usecases/reports/remote-get-audit-config';
import { AuditConfigResponse } from 'domain/usecases/reports/get-audit-config';

export const useGetAuditConfig = (locationId: string | undefined, enabled: boolean = true) => {
  return useQuery<AuditConfigResponse>({
    queryKey: ['auditConfig', locationId],
    queryFn: async () => {
      if (!locationId) {
        throw new Error('Location ID is required');
      }
      const getAuditConfigService = makeRemoteGetAuditConfig();
      const result = await getAuditConfigService.getConfig({ locationId });

      // Check if result is an error response
      if ('error' in result) {
        throw new Error(result.error || 'Failed to fetch audit config');
      }

      return result as AuditConfigResponse;
    },
    enabled: enabled && !!locationId,
    retry: 1,
  });
};
